import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader.js'
import { write, utils } from 'xlsx'

class ComplaintReports extends React.Component {
  state = {
    country_list: [],
    Data: [],
    reportUrl: '',
    isSearching: false,

    // filters
    start_date: '',
    country: '',
    end_date: '',
    status: '',
    keyword: '',
    type: 'C',
  }

  componentDidMount() {
    this.loadData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.type !== prevProps.match.params.type) {
      this.setState({
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        country: '',
        end_date: moment().format('YYYY-MM-DD'),
        booking_date: null,
        booking_from: null,
        booking_to: null,
        status: '',

        Data: [],
      })
    }
  }

  loadData() {
    this.setState(
      {
        start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      () => {
        this.detailsSummary()
      }
    )
    this.getCountries()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  clearSearch = async () => {
    this.setState({
      status: '',
      country: '',
      start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      Data: [],
    })
  }

  searchData = async () => {
    this.detailsSummary()
  }

  detailsSummary = async () => {
    var dateDMY1 = moment(this.state.start_date).format('YYYY-MM-DD')
    var dateDMY2 = moment(this.state.end_date).format('YYYY-MM-DD')
    let data = {
      status: this.state.status ? this.state.status : null,
      keyword: this.state.keyword,
      country: this.state.country,
      type: this.state.type,
    }

    if (dateDMY1 && dateDMY1 != 'Invalid date') data.start_date = dateDMY1
    if (dateDMY2 && dateDMY2 != 'Invalid date') data.end_date = dateDMY2

    this.setState({
      isSearching: true,
      Data: [],
    })

    await axios
      .post(Constant.getAPI() + `/reports/complaint-report`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details?.[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 6
    if (diffMonths > 6) {
      return true
    } else {
      return false
    }
  }

  handleChange = (event) => {
    event.persist()

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (
          (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
          this.checkDateDifference(this.state.start_date, this.state.end_date)
        ) {
          if (event?.target?.name == 'start_date') {
            this.setState({
              end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD'),
            })
          } else {
            this.setState({
              start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD'),
            })
          }
        }
        if (event?.target?.name == 'type') {
          this.detailsSummary()
        }
      }
    )
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  render() {
    let columns = [
      {
        name: 'booking_id',
        label: 'Booking Id',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order_number',
        label: 'Order No',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, { rowData }) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {this.state.type == 'C' && (
                  <Link to={'booking-ordering/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'CH' && (
                  <Link to={'chalet-booking-details/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'E' && (
                  <Link to={'new-evt/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'S' && (
                  <Link to={'store-bookings-details/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'created_at',
        label: 'Date Of Complaint',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'customer_name',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'customer_phone',
        label: 'Phone #',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'category',
        label: 'Category',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'item_name',
        label: 'Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'title',
        label: 'Type of Complaint',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'description',
        label: 'Description',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 100 }}>{value}</div>
          },
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'action',
        label: 'Action Taken',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'created_by',
        label: 'Created By',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'updated_by',
        label: 'Updated By',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (columns[idx].label && columns[idx].display == 'true') {
              temp[columns[idx].label] = v
            }
          })
          if (temp?.TRIP_DATE && temp?.START_TIME) {
            temp.TRIP_DATE_TIME = temp.TRIP_DATE + ' ' + temp.START_TIME
          }
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div
                      className="d-inline"
                      style={{ width: 400 }}
                    >
                      <h4>Complaint Report</h4>
                    </div>
                    <select
                      name="type"
                      className="form-control m-l-30"
                      value={this.state.type}
                      onChange={this.handleChange}
                    >
                      <option value={'C'}>CRUISE</option>
                      <option value={'CH'}>CHALET</option>
                      <option value={'E'}>EVENT</option>
                      <option value={'S'}>STORE</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Complaint Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">Search</label>
                            <div className="col-md-9">
                              <input
                                type="text"
                                id="keyword"
                                className="form-control"
                                value={this.state.keyword}
                                name="keyword"
                                placeholder="Order No"
                                onKeyPress={this.handleKeyPress}
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12"
                          style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                        ></div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Complaint Status</label>
                            <div className="col-sm-9">
                              <select
                                name="status"
                                className="form-control"
                                value={this.state.status}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                <option value="Open">Open</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Resolved">Resolved</option>
                                <option value="Closed">Closed</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                id="date"
                                name="start_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                id="date"
                                name="end_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="text-right col-12">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.searchData}
                                    disabled={
                                      (!this.state.start_date && this.state.end_date) ||
                                      (this.state.start_date && !this.state.end_date) ||
                                      (!this.state.booking_from && this.state.booking_to) ||
                                      (this.state.booking_from && !this.state.booking_to) ||
                                      (!this.state.start_date &&
                                        !this.state.end_date &&
                                        !this.state.booking_from &&
                                        !this.state.booking_to)
                                    }
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Complaint Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ComplaintReports
